import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const OrderService = {
  getOrderDetails,
  getInvoiceDetails,
  getAdminOrderDetails,
  getAdminInvoiceDetails,
};

async function getOrderDetails(user_id, limit, offset, status_filter, usertype) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const params = new URLSearchParams();
    if (status_filter) params.append('status_filter', status_filter);
    const queryParams = params.toString() ? `?${params.toString()}` : "";

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/orders/order-details/${user_id}/${usertype}/${limit}/${offset}${queryParams}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getInvoiceDetails(user_id, limit, offset, status_filter, usertype) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const params = new URLSearchParams();
    if (status_filter) params.append('status_filter', status_filter);
    const queryParams = params.toString() ? `?${params.toString()}` : "";

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/orders/invoice-details/${user_id}/${usertype}/${limit}/${offset}${queryParams}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAdminOrderDetails(limit, offset, search, userType) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (userType) params.append('user_type', userType);
    const queryParams = params.toString() ? `?${params.toString()}` : "";

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/orders/all-orders/${limit}/${offset}${queryParams}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAdminInvoiceDetails(limit, offset, search, userType) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (userType) params.append('user_type', userType);
    const queryParams = params.toString() ? `?${params.toString()}` : "";

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/orders/all-invoices/${limit}/${offset}${queryParams}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}